import {useEffect, useState} from "react";
import {cfgPartial, cfgUpdate, getOrders} from "../api/api";
import {useApp} from "../Contex";

export default function Dashboard() {
    const {refresh, permissions} = useApp()
    return (
        <>
            <RestaurantStatus/>
            <OrderingOverview/>
        </>
    );

    function RestaurantStatus() {
        const [closedState, setClosedState] = useState(false);

        function fetchData(){
            cfgPartial(["closed"]).then((res)=>{
                if(res.ok){
                    setClosedState(res.data.closed === "1")
                }
            })
        }

        function toggleClosed() {
            const closed = closedState ? "0" : "1";
            cfgUpdate({closed}).then((res) => {
                if (res.ok) {
                    fetchData()
                }
            })
        }

        useEffect(() => {
            fetchData()
        }, [refresh]);


        return <div className={`card mb-2 p-3 d-flex justify-content-between align-items-center flex-row rounded-4`}>
            <div>
                <h3 className={`mb-0 fw-bold`}>
                    Restaurangstatus: <span
                    className={closedState ? "text-danger" : "text-success"}>{closedState ? "STÄNGT" : "ÖPPET"}</span>
                </h3>
            </div>
            {permissions.write &&
                <button
                    onClick={toggleClosed}
                    className={`btn btn-${closedState ? 'success' : 'danger'} fw-bold d-flex align-items-center gap-2 px-3 py-2`}
                >
                    {closedState ? "ÖPPNA" : "STÄNG"}
                    <i className="bi bi-arrow-repeat"/>
                </button>
            }
        </div>

    }

    function OrderingOverview() {
        const [orderStats, setOrderStats] = useState({ sum: 0, count: 0, payments: {} });

        const fetchOrders = () => {
            const today = new Date();
            const dateStr = `${today.getFullYear()}${(today.getMonth() + 1)
                .toString()
                .padStart(2, '0')}${(today.getDate()).toString().padStart(2, '0')}`;

            getOrders(dateStr, true).then((res) => {
                if (res.ok) {
                    const orders = res.orders || [];
                    let sum = 0;
                    let payments = {};

                    for (const { order00 } of orders) {
                        sum += parseInt(order00.belopp, 10);
                        payments[order00.betkod] = (payments[order00.betkod] || 0) + 1;
                    }

                    setOrderStats({ sum, count: orders.length, payments });
                }
            });
        };

        useEffect(() => {
            fetchOrders();
        }, [refresh]);

        const nameMap = {
            swis: "Swish",
            viva: "Viva",
        };

        const paymentKeys = Object.keys(orderStats.payments).sort();

        return (
            <div className="card p-4 shadow rounded-4">
                <h3 className="fw-bold mb-4">Orderöversikt</h3>
                <div className="d-flex flex-wrap justify-content-between align-items-start gap-3">
                    <div>
                        <p className="mb-1">Antal beställningar</p>
                        <h5 className="fw-semibold">{orderStats.count} st</h5>
                        <p className="mt-3 mb-1">Totalsumma</p>
                        <h5 className="fw-semibold">
                            {(orderStats.sum / 100).toLocaleString("sv-SE")} kr
                        </h5>
                    </div>

                    <div className="card bg-light p-3 rounded-3 border-1">
                        <p className="fw-semibold mb-2">Betalningsfördelning</p>
                        {paymentKeys.length > 0 ? (
                            paymentKeys.map((key) => (
                                <p key={key} className="mb-1">
                                    {nameMap[key] ?? key}: <span className="fw-medium">{orderStats.payments[key]} st</span>
                                </p>
                            ))
                        ) : (
                            <p className="text-muted mb-0">Inga betalningar</p>
                        )}
                    </div>
                </div>
            </div>
        );
    }


}
